import config from 'config';
import { format } from 'date-fns';
import { DvmExamOutput } from 'gql/types';
import Papa from 'papaparse';
import { getTranslation } from 'utils/getTranslation';
import * as XLSX from 'xlsx';

const t = getTranslation('donor.GeneralDvmExamTable');

export type DvmExamExportFormat = 'csv' | 'xlsx';

const buildRows = (exams: DvmExamOutput[]) =>
  exams.map((exam) => ({
    [t('donorId')]: exam.donor.shortId,
    [t('petName')]: exam.donor.name,
    [t('lastName')]: exam.donor.user?.lastName ?? '',
    [t('nextExamDue')]: exam.nextExamDue
      ? format(new Date(exam.nextExamDue), config.DATE_FORMATS.DATE)
      : '',
    [t('region')]: exam.donorRegion ?? '',
    [t('location')]: exam.donorLocation ?? '',
    [t(
      'veterinarian'
    )]: `${exam.performedBy.firstName} ${exam.performedBy.lastName}`,
  }));

const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportDvmExams = (
  exams: DvmExamOutput[],
  exportFormat: DvmExamExportFormat
) => {
  const rows = buildRows(exams);
  const fileName = `dvm-exams_${format(
    new Date(),
    config.DATE_FORMATS.SHORT_DATE
  )}`;

  if (exportFormat === 'csv') {
    const csv = Papa.unparse(rows);
    downloadBlob(
      new Blob([csv], { type: 'text/csv;charset=utf-8;' }),
      `${fileName}.csv`
    );
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, t('exportSheetName'));
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
